import type { ProjectFile } from '@archer/shared';
import { useAuth } from '../auth/store';
import type { ArcherApiClient } from '@archer/shared';
import type { ProjectSummary, StorageAdapter } from './types';

export class CloudStorageAdapter implements StorageAdapter {
  readonly kind = 'cloud' as const;
  readonly label = 'Archer cloud';
  readonly api: ArcherApiClient;

  constructor(api: ArcherApiClient) {
    this.api = api;
  }

  async list(): Promise<ProjectSummary[]> {
    const { projects } = await this.api.listProjects();
    return projects.map((p) => ({
      ...p,
      storageKind: 'cloud' as const,
      storageRef: p.id,
    }));
  }

  async load(storageRef: string): Promise<ProjectFile> {
    const { file } = await this.api.getProject(storageRef);
    return file;
  }

  async save(storageRef: string, file: ProjectFile): Promise<void> {
    if (storageRef !== file.id) {
      await this.api.createProject(file.name, file);
      return;
    }
    await this.api.updateProject(storageRef, file);
  }

  async remove(storageRef: string): Promise<void> {
    await this.api.deleteProject(storageRef);
  }
}

export const useCloudAdapter = (): CloudStorageAdapter | null => {
  const api = useAuth((s) => s.api);
  return api ? new CloudStorageAdapter(api) : null;
};

